var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"div"},[_c('canvas',{ref:"plan",staticClass:"plan-canvas",on:{"mousedown":_vm.onCanvasMouseDown,"mouseup":_vm.onCanvasMouseUp,"mousemove":_vm.onCanvasMouseMove}}),_c('div',{staticStyle:{"display":"none"}},[_c('img',{ref:"source"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }